import type { UiVariant } from '@/ui/view-props';

export interface UserFeatures {
  recent_results: boolean;
  whos_hot: boolean;
  global_podium: boolean;
  date_range_filters: boolean;
  head_to_head: boolean;
  milestone_badges: boolean;
  profit_loss_trend: boolean;
  player_search_filter: boolean;
  session_calendar_search: boolean;
  enable_vision: boolean;
  live_scoreboard: boolean;
  achievement_badges: boolean;
  seasonal_leaderboard: boolean;
  session_templates: boolean;
  realtime_session: boolean;
  extra_juice: boolean;
  ui_variant?: UiVariant;
  theme?: string;
  active_session_id?: string | null;
}

export const DEFAULT_FEATURES: UserFeatures = {
  recent_results: true,
  whos_hot: true,
  global_podium: true,
  date_range_filters: true,
  head_to_head: true,
  milestone_badges: true,
  profit_loss_trend: true,
  player_search_filter: true,
  session_calendar_search: true,
  enable_vision: false,
  live_scoreboard: true,
  achievement_badges: true,
  seasonal_leaderboard: true,
  session_templates: true,
  realtime_session: true,
  extra_juice: true,
  ui_variant: 'classic',
  theme: 'system',
  active_session_id: null,
};
